define('bizzabo/consts',[], function() {

    var Consts = {};

    Consts.Notifications = {
        analytics : {
            TRACK_EVENT : 'analytics.trackEvent',
            SET_USER_TYPE : 'analytics.setUserType'
        },
        activeEvent : {
            EVENT_INFO_SAVED : 'activeEvent.eventInfoSaved',
            AGENDA_SAVED : 'activeEvent.agendaSaved',
            EVENT_PUBLISHED : 'activeEvent.eventPublished',
            SWITCHED : 'activeEvent.switched'
        },
        eventBrite : {
            OAUTH_SUCCESS : 'eventBrite.oAuthSuccess',
            OAUTH_FAILURE : 'eventBrite.oAuthFailure',
            SHOW_CONNECT_VIEW : 'eventBrite.showConnectView'
        },
        etouches : {
            SHOW_CONNECT_VIEW : 'etouches.showConnectView'
        },
        mainPage : {
            HIDER_CLICKED : "mainPage.hiderClicked",
            PREPARE_SUCCESS : 'mainPage.prepareSuccess',
            PREPARE_FAILURE : 'mainPage.prepareFailure',
            SWITCHED : 'mainPage.switched',

            INFO_PAGE_LOADED : 'mainPage.infoPageLoaded',
            AGENDA_PAGE_LOADED : 'mainPage.agendaPageLoaded',
            DASHBOARD_PAGE_LOADED : 'mainPage.dashboardPageLoaded',
            PROMOTE_PAGE_LOADED : 'mainPage.promotePageLoaded',
            GROW_PAGE_LOADED : 'mainPage.growPageLoaded',
            SPONSORS_PAGE_LOADED : 'mainPage.sponsorsPageLoaded',
            PARTNERS_PAGE_LOADED : 'mainPage.partnersPageLoaded',
            COMMUNITY_PAGE_LOADED : 'mainPage.communityPageLoaded',
            POLLS_PAGE_LOADED : 'mainPage.pollsPageLoaded',

            SAVE_ALL_REQUEST : "mainPage.saveAllRequest",
            SAVE_ALL_REQUEST_COMPLETED : "mainPage.saveAllRequestCompleted",
            PUBLISH_ALL_REQUEST : "mainPage.publishAllRequest",
            PUBLISH_ALL_REQUEST_COMPLETED : "mainPage.publishAllRequestCompleted"
        },
        leftPanel : {
            SWITCH_TAB_REQUEST : "leftPanel.switchTabRequest",
            TAB_SWITCHED : "leftPanel.tabSwitched"
        },
        rightPanel : {
            SWITCHED : "rightPanel.switched"
        },
        agenda : {
            SCROLL_TO_NEXT_DAY : "scrollToNextDay",
            SCROLL_TO_PREV_DAY : "scrollToPrevDay",
            GRID_CLICK : "gridClick"
        },
        notificationMsgs : {
            TRIGGER_NOTIFICATION_MSG : "notificationMsgs.triggerNotificationMsg"
        },
        router : {
            NAVIGATE_REQUEST : "router.navigate",
            EVENT_ID_CHANGED : "router.eventIdChanged"
        },
        signin : {
            SIGNED_IN : "signin.signedIn",
            SIGNED_OUT : "signin.signedOut"
        },
        validation : {
            KEY_PRESS_VALIDATION : "keyPressValidation"
        },
        sponsors : {
            DELETE_SPONSOR : "sponsors.deleteSponsor",
            CLEAR_SELECTED_SPONSOR : "sponsors.clearSelectedPartner"
        },
        linkedin : {
            AUTH : "linkedin.auth"
        },
        multiAdmin : {
            TAKE_OVER : "multiAdmin.takeOver",
            EDITOR_NAME_CHANGED : "multiAdmin.editorNameChanged"
        }
    };

    Consts.Strings = {
        eventDraft : {
            DEFAULT_DRAFT_NAME : 'New Event'
        },
        notificationMsgs : {
            SESSION_COLLISION : "Session overlaps others"
        },
        VALIDATION_NAME : "validation"
    };

    Consts.UI = {
        mainView : {
            MAIN_VIEW_SWITCH_MIN_DELAY : 200,
            TAB_LOADER_HIDE_DELAY : 100
        },
        tabClasses : {
            INFORMATION : 'information',
            AGENDA : 'agenda',
            DASHBOARD : 'dashboard',
            PROMOTE : 'promote',
            SPONSORS : 'sponsors',
            PARTNERS : 'partners',
            COMMUNITY : "community",
            SERVICE_PLAN : "servicePlan",
            POLLS : "polls"
        },
        agenda : {
            TRACK_TITLES_WIDTH_DIFF : 0.7, // track title width, relative to the column width
            DEFAULT_SESSION_DURATION : 60, // in minutes
            MIN_SESSION_DURATION : 5, // in minutes
            SESSION_DURATION_AUTO_COMPLETE_OPTIONS : [30, 45, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330, 360, 390, 420, 450, 480, 510, 540, 570, 600,
                630, 660, 690, 720, 750, 780, 810, 840, 870, 900, 930, 960, 990, 1020, 1050, 1080, 1110, 1140, 1170, 1200, 1230, 1260, 1290, 1320, 1350, 1380, 1410, 1440], // options in minutes
            DEFAULT_HOUR : "08:00",
            MAX_NUM_OF_TRACKS : 30,
            MAX_NUM_OF_DAYS : 30
        },
        notificationMsgs : {
            errorLevelsClasses : {
                ERROR : "error",
                WARNING : "warning",
                TIP : "tip",
                SUCCESS : "success",
                LOADING : "loading"
            }
        }
    };

    Consts.SocialShare = {
        Providers : {
            LINKEDIN : "linkedin",
            FACEBOOK : "facebook",
            TWITTER : "twitter"
        },
        Interval : {
            WEEKLY : "weekly",
            DAILY : "daily"
        }
    };

    Consts.Countries = {
        AF : "Afghanistan",
        AX : "Åland Islands",
        AL : "Albania",
        DZ : "Algeria",
        AS : "American Samoa",
        AD : "Andorra",
        AO : "Angola",
        AI : "Anguilla",
        AQ : "Antarctica",
        AG : "Antigua And Barbuda",
        AR : "Argentina",
        AM : "Armenia",
        AW : "Aruba",
        AU : "Australia",
        AT : "Austria",
        AZ : "Azerbaijan",
        BS : "Bahamas",
        BH : "Bahrain",
        BD : "Bangladesh",
        BB : "Barbados",
        BY : "Belarus",
        BE : "Belgium",
        BZ : "Belize",
        BJ : "Benin",
        BM : "Bermuda",
        BT : "Bhutan",
        BO : "Bolivia, Plurinational State Of",
        BQ : "Bonaire, Sint Eustatius And Saba",
        BA : "Bosnia And Herzegovina",
        BW : "Botswana",
        BV : "Bouvet Island",
        BR : "Brazil",
        IO : "British Indian Ocean Territory",
        BN : "Brunei Darussalam",
        BG : "Bulgaria",
        BF : "Burkina Faso",
        BI : "Burundi",
        KH : "Cambodia",
        CM : "Cameroon",
        CA : "Canada",
        CV : "Cape Verde",
        KY : "Cayman Islands",
        CF : "Central African Republic",
        TD : "Chad",
        CL : "Chile",
        CN : "China",
        CX : "Christmas Island",
        CC : "Cocos (Keeling) Islands",
        CO : "Colombia",
        KM : "Comoros",
        CG : "Congo",
        CD : "Congo, The Democratic Republic Of The",
        CK : "Cook Islands",
        CR : "Costa Rica",
        CI : "Côte D&apos;ivoire",
        HR : "Croatia",
        CU : "Cuba",
        CW : "Curaçao",
        CY : "Cyprus",
        CZ : "Czech Republic",
        DK : "Denmark",
        DJ : "Djibouti",
        DM : "Dominica",
        DO : "Dominican Republic",
        EC : "Ecuador",
        EG : "Egypt",
        SV : "El Salvador",
        GQ : "Equatorial Guinea",
        ER : "Eritrea",
        EE : "Estonia",
        ET : "Ethiopia",
        FK : "Falkland Islands (Malvinas)",
        FO : "Faroe Islands",
        FJ : "Fiji",
        FI : "Finland",
        FR : "France",
        GF : "French Guiana",
        PF : "French Polynesia",
        TF : "French Southern Territories",
        GA : "Gabon",
        GM : "Gambia",
        GE : "Georgia",
        DE : "Germany",
        GH : "Ghana",
        GI : "Gibraltar",
        GR : "Greece",
        GL : "Greenland",
        GD : "Grenada",
        GP : "Guadeloupe",
        GU : "Guam",
        GT : "Guatemala",
        GG : "Guernsey",
        GN : "Guinea",
        GW : "Guinea-Bissau",
        GY : "Guyana",
        HT : "Haiti",
        HM : "Heard Island And Mcdonald Islands",
        VA : "Holy See (Vatican City State)",
        HN : "Honduras",
        HK : "Hong Kong",
        HU : "Hungary",
        IS : "Iceland",
        IN : "India",
        ID : "Indonesia",
        IR : "Iran, Islamic Republic Of",
        IQ : "Iraq",
        IE : "Ireland",
        IM : "Isle Of Man",
        IL : "Israel",
        IT : "Italy",
        JM : "Jamaica",
        JP : "Japan",
        JE : "Jersey",
        JO : "Jordan",
        KZ : "Kazakhstan",
        KE : "Kenya",
        KI : "Kiribati",
        KP : "Korea, Democratic People&apos;s Republic Of",
        KR : "Korea, Republic Of",
        KW : "Kuwait",
        KG : "Kyrgyzstan",
        LA : "Lao People&apos;s Democratic Republic",
        LV : "Latvia",
        LB : "Lebanon",
        LS : "Lesotho",
        LR : "Liberia",
        LY : "Libyan Arab Jamahiriya",
        LI : "Liechtenstein",
        LT : "Lithuania",
        LU : "Luxembourg",
        MO : "Macao",
        MK : "Macedonia, The Former Yugoslav Republic Of",
        MG : "Madagascar",
        MW : "Malawi",
        MY : "Malaysia",
        MV : "Maldives",
        ML : "Mali",
        MT : "Malta",
        MH : "Marshall Islands",
        MQ : "Martinique",
        MR : "Mauritania",
        MU : "Mauritius",
        YT : "Mayotte",
        MX : "Mexico",
        FM : "Micronesia, Federated States Of",
        MD : "Moldova, Republic Of",
        MC : "Monaco",
        MN : "Mongolia",
        ME : "Montenegro",
        MS : "Montserrat",
        MA : "Morocco",
        MZ : "Mozambique",
        MM : "Myanmar",
        NA : "Namibia",
        NR : "Nauru",
        NP : "Nepal",
        NL : "Netherlands",
        NC : "New Caledonia",
        NZ : "New Zealand",
        NI : "Nicaragua",
        NE : "Niger",
        NG : "Nigeria",
        NU : "Niue",
        NF : "Norfolk Island",
        MP : "Northern Mariana Islands",
        NO : "Norway",
        OM : "Oman",
        PK : "Pakistan",
        PW : "Palau",
        PS : "Palestinian Territory",
        PA : "Panama",
        PG : "Papua New Guinea",
        PY : "Paraguay",
        PE : "Peru",
        PH : "Philippines",
        PN : "Pitcairn",
        PL : "Poland",
        PT : "Portugal",
        PR : "Puerto Rico",
        QA : "Qatar",
        RE : "Réunion",
        RO : "Romania",
        RU : "Russian Federation",
        RW : "Rwanda",
        BL : "Saint Barthélemy",
        SH : "Saint Helena, Ascension And Tristan Da Cunha",
        KN : "Saint Kitts And Nevis",
        LC : "Saint Lucia",
        MF : "Saint Martin (French Part)",
        PM : "Saint Pierre And Miquelon",
        VC : "Saint Vincent And The Grenadines",
        WS : "Samoa",
        SM : "San Marino",
        ST : "Sao Tome And Principe",
        SA : "Saudi Arabia",
        SN : "Senegal",
        RS : "Serbia",
        SC : "Seychelles",
        SL : "Sierra Leone",
        SG : "Singapore",
        SX : "Sint Maarten (Dutch Part)",
        SK : "Slovakia",
        SI : "Slovenia",
        SB : "Solomon Islands",
        SO : "Somalia",
        ZA : "South Africa",
        GS : "South Georgia And The South Sandwich Islands",
        ES : "Spain",
        LK : "Sri Lanka",
        SD : "Sudan",
        SR : "Suriname",
        SJ : "Svalbard And Jan Mayen",
        SZ : "Swaziland",
        SE : "Sweden",
        CH : "Switzerland",
        SY : "Syrian Arab Republic",
        TW : "Taiwan",
        TJ : "Tajikistan",
        TZ : "Tanzania, United Republic Of",
        TH : "Thailand",
        TL : "Timor-Leste",
        TG : "Togo",
        TK : "Tokelau",
        TO : "Tonga",
        TT : "Trinidad And Tobago",
        TN : "Tunisia",
        TR : "Turkey",
        TM : "Turkmenistan",
        TC : "Turks And Caicos Islands",
        TV : "Tuvalu",
        UG : "Uganda",
        UA : "Ukraine",
        AE : "United Arab Emirates",
        GB : "United Kingdom",
        US : "United States",
        UM : "United States Minor Outlying Islands",
        UY : "Uruguay",
        UZ : "Uzbekistan",
        VU : "Vanuatu",
        VE : "Venezuela, Bolivarian Republic Of",
        VN : "Viet Nam",
        VG : "Virgin Islands, British",
        VI : "Virgin Islands, U.S.",
        WF : "Wallis And Futuna",
        EH : "Western Sahara",
        YE : "Yemen",
        ZM : "Zambia",
        ZW : "Zimbabwe"
    };

    return Consts;

});
